import React from "react";

import PropTypes from "prop-types";
import "./styles.scss";

const LabeledItem = ({ label, children }) => (
  <div>
    <p className={"label"}>{label}</p>
    {children}
  </div>
);

LabeledItem.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
};

export default LabeledItem;
